export default __webpack_public_path__ + "static/media/egg_video01.314e9f37.jpg";